import React, { useEffect } from "react";

//spinner
import Loader from "react-loader-spinner";
const Spinner = () => {
  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  return (
    <div
      style={{
        height: "100vh",
        display: "flex",
        justifyContent: "center",
        alignItems: "center",
      }}
    >
      <Loader color="#fa0171" type="Puff" height={150} width={150} />
    </div>
  );
};

export default Spinner;
